/* @flow */
import Group from 'entities/Group';
import Message from 'entities/Message';
import React from 'react';
import cx from 'classnames';
import './styles/GroupMessageBase.scss';

class GroupMessageBase extends React.Component {
  static propTypes = {
    message: React.PropTypes.instanceOf(Message).isRequired,
    border: React.PropTypes.bool,
    backgroundColor: React.PropTypes.string,
  };

  static contextTypes = {
    group: React.PropTypes.instanceOf(Group),
  };

  static childContextTypes = {
    message: React.PropTypes.instanceOf(Message).isRequired,
  };

  getChildContext() {
    return {
      message: this.props.message,
    };
  }

  render() {
    let style = {};
    if (this.props.backgroundColor) {
      style = Object.assign(style, {
        backgroundColor: this.props.backgroundColor,
      });
    }

    return (
      <div className={cx('GroupMessageBase', this.props.className)}>
        <div
          {...this.props}
          style={style}
          className={cx({
            'GroupMessageBase-card': true,
            'GroupMessageBase-bordered': this.props.border,
            'GroupMessageBase-failed': this.props.message.getStatus() === 'failed',
          })}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default GroupMessageBase;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessageBase.jsx